import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { format } from "date-fns";
import { getErrorsMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";
class FileComments extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            comment: '',
            comments: [],
        };
        this.save = this.save.bind(this);
        this.handleCommentChange = this.handleCommentChange.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
        this.delete = this.delete.bind(this);
    }

    componentDidMount() {
        this.getComments()
        const lang = this.context.lang; 
        FormValidation.formValidation(KTUtil.getById('frm'), {
            fields: {
                comment: {
                    validators: {
                        notEmpty: {
                            message: lang.get('messages.comentario_requerido')
                        },
                        stringLength: {
                            min: 4,
                            max: 800,
                            message: lang.get('messages.el_comentario_debe_tener_una_longitud_minima_de_4')
                        },
                    }
                },
            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                submitButton: new FormValidation.plugins.SubmitButton(),
                bootstrap: new FormValidation.plugins.Bootstrap({
                    eleInvalidClass: '',
                    eleValidClass: '',
                })
            },
        }).on('core.form.valid', () => {
            this.save();
        });
    }

    async getComments(){
        const res = await axios.get('/api/documents/' + this.props.document_id + '/comments')
        const data = res.data
        this.setState({comments: data})
    }

    handleCommentChange(e) {
        this.setState({ comment: e.target.value });
    }

    async save() {
        const lang = this.context.lang; 
        window.blockUI();
        KTUtil.btnWait(KTUtil.getById('btnSend'), 'spinner spinner-right spinner-white pr-15', "Procesando...");

        const params = JSON.stringify({
            comment: this.state.comment
        });

        await axios.post(
            '/api/documents/' + this.props.document_id + '/comments',
            params,
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            window.unblockUI();
            KTUtil.btnRelease(KTUtil.getById('btnSend'));
            this.getComments();
            this.setState({ comment: "" });

            swal.fire({
                text: "Guardado",
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            });
        })
        .catch((error) => {
            window.unblockUI();
            const message = getErrorsMessage(error);

            KTUtil.btnRelease(KTUtil.getById('btnSend'));

            swal.fire({
                text: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: lang.get('messages.aceptar'),
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            }).then(function() {
                KTUtil.scrollTop();
            });
        });
    }

    confirmDelete(id) {
        const lang = this.context.lang; 
        swal.fire({
            text: lang.get('messages.desea_continuar_con_la_eliminacion'),
            showCancelButton: true,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Continuar",
            cancelButtonText: "Cancelar",
            customClass: {
                confirmButton: "btn font-weight-bold btn-primary",
                cancelButton: "btn font-weight-bold btn-danger"
            }
        }).then((result) => {
            if (result.isConfirmed) {
                this.delete(id);
            }
        });
    }

    async delete(id) {
        window.blockUI();
        await axios.delete(
            '/api/documents/comments/' + id,
            {},
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            window.unblockUI();
            this.getComments();
        })
        .catch((error) => {
            window.unblockUI();
            swal.fire({
                text: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            }).then(function() {
                KTUtil.scrollTop();
            });
        });
    }

    render() {
        const { lang } = this.context; 
        return (
            <div className="card card-custom gutter-b">
                <div className="card-body">
                    <h5 className="text-dark font-weight-bold my-1 mb-10">
                        {lang.get('messages.comentarios')}
                        <br/>
                        <small className="text-muted font-weight-bold">{lang.get('messages.dar_de_alta_un_comentario')}</small>
                    </h5>
                    { (this.props.permissions.documents_actions.includes('all') || this.props.permissions.documents_actions.includes('comment') ) &&
                    <form id="frm">
                        <div className="form-group">
                            <label>{lang.get('messages.nuevo_comentario')}</label>
                            <textarea rows="4" id="comment" name="comment" className="form-control form-control-solid" value={this.state.comment} onChange={this.handleCommentChange}></textarea>
                        </div>
                        <div className="form-group text-right">
                            <button id="btnSend" type="submit" className="btn btn-primary ml-4">
                                {lang.get('messages.enviar')}
                            </button>
                        </div>
                    </form>
                    }
                    <br/>

                    {this.state.comments.map((c, i) => {
                        const displayName = c.user === null ? c.person.name : c.user.name;
                        return (
                            <div key={i} className="form-group">
                                <div>
                                    <strong className="mr-4">{displayName}</strong> <small>{format(new Date(c.created_at), 'dd/MM/yyyy')}</small>
                                </div>
                                <div className="text-muted">
                                    {c.comment}
                                    <button type="button" className="ml-5 btn btn-sm btn-link-danger" onClick={() => this.confirmDelete(c.id)}>
                                        {lang.get('messages.eliminar')}
                                    </button>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

export default FileComments;

if (document.getElementById('FileComments')) {
    ReactDOM.render(<FileComments />, document.getElementById('FileComments'));
}
